import { ITheme } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { flexDirection: string; loading: boolean }, ITheme>(
  {
    input: {
      margin: [24, 0, 32],
      borderRadius: 12,
      height: 64,
    },
    animation: {
      backgroundColor: 'var(--x-bg-7)',
    },
  },
  { name: 'LoadingRephrasedResults' },
);
export default useStyles;
